const InactivityDetector = function(callback, timeoutMs) {
	let timeout

	function activate() {
		// const mins = timeoutMs / 1000 / 60
		// console.log('InactivityDetector activated, timeout in mins=' + mins)
		window.onload = resetTimer
		document.addEventListener('mousemove', resetTimer)
		document.addEventListener('keypress', resetTimer)
		document.addEventListener('scroll', resetTimer)
		document.addEventListener('click', resetTimer)
	}

	function deactivate() {
		window.onload = null
		document.removeEventListener('mousemove', resetTimer)
		document.removeEventListener('keypress', resetTimer)
		document.removeEventListener('scroll', resetTimer)
		document.removeEventListener('click', resetTimer)
	}

	function inactivityAction() {
		// console.log('Inactivity detected, calling action.')
		if (callback) callback()
	}

	function resetTimer() {
		clearTimeout(timeout)
		timeout = setTimeout(inactivityAction, timeoutMs)
	}

	return { activate, deactivate, resetTimer }
}

export default InactivityDetector
